import { ActionKeys } from './constants';

export function initFilters(
  filterGroupName: string,
  arrayFilters: string[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialValues: any,
) {
  return <const>{
    type: ActionKeys.FILTER_INIT,
    payload: {
      filterGroupName,
      arrayFilters,
      initialValues,
    },
  };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function changeFilter(filterGroupName: string, filterName: string, value: any) {
  return <const>{
    type: ActionKeys.FILTER_CHANGED,
    payload: {
      filterGroupName,
      filterName,
      value,
    },
  };
}

export function resetFilters(filterGroupName: string) {
  return <const>{
    type: ActionKeys.FILTER_RESET,
    payload: {
      filterGroupName,
    },
  };
}

export function openSaveFilterModal() {
  return <const>{
    type: ActionKeys.FILTER_OPEN_SAVE_MODAL,
  };
}

export function closeSaveFilterGroupModal() {
  return <const>{
    type: ActionKeys.FILTER_CLOSE_SAVE_MODAL,
  };
}

export function openDeleteModal() {
  return <const>{
    type: ActionKeys.FILTER_OPEN_DELETE_MODAL,
  };
}

export function closeDeleteModal() {
  return <const>{
    type: ActionKeys.FILTER_CLOSE_DELETE_MODAL,
  };
}

export function setSearchQueryValue(value: string) {
  return <const>{
    type: ActionKeys.FILTER_SET_QUERY_VALUE,
    payload: {
      value,
    },
  };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function saveFilterGroup(filterGroupName: string, filters: any) {
  return <const>{
    type: ActionKeys.FILTER_SAVE_FILTER_GROUP,
    payload: {
      filterGroupName,
      filters,
    },
  };
}

export function saveFilterGroupSuccess(data) {
  return <const>{
    type: ActionKeys.FILTER_SAVE_FILTER_GROUP_SUCCESS,
    payload: {
      data,
    },
  };
}

export function saveFilterGroupError(errorMessage: string) {
  return <const>{
    type: ActionKeys.FILTER_SAVE_FILTER_GROUP_ERROR,
    payload: {
      errorMessage,
    },
  };
}

export function getFilterGroups() {
  return <const>{
    type: ActionKeys.FILTER_GET_FILTER_GROUPS,
  };
}

export function getFilterGroupsSuccess(data) {
  return <const>{
    type: ActionKeys.FILTER_GET_FILTER_GROUPS_SUCCESS,
    payload: {
      data,
    },
  };
}

export function getFilterGroupsError(errorMessage: string) {
  return <const>{
    type: ActionKeys.FILTER_GET_FILTER_GROUPS_ERROR,
    payload: {
      errorMessage,
    },
  };
}

export function deleteFilterGroup(filterGroupObjectID: string) {
  return <const>{
    type: ActionKeys.FILTER_DELETE_FILTER_GROUP,
    payload: {
      filterGroupObjectID,
    },
  };
}

export function deleteFilterGroupSuccess() {
  return <const>{
    type: ActionKeys.FILTER_DELETE_FILTER_GROUP_SUCCESS,
  };
}

export function deleteFilterGroupError(errorMessage: string) {
  return <const>{
    type: ActionKeys.FILTER_DELETE_FILTER_GROUP_ERROR,
    payload: {
      errorMessage,
    },
  };
}

export function showNewTab() {
  return <const>{
    type: ActionKeys.FILTER_SHOW_NEW_TAB,
  };
}

export function hideNewTab() {
  return <const>{
    type: ActionKeys.FILTER_HIDE_NEW_TAB,
  };
}

export function determineTabName() {
  return <const>{
    type: ActionKeys.FILTER_DETERMINE_TAB_NAME,
  };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function removeFilter(filterValues: any[], filterName: string, newFilterValue: any) {
  return <const>{
    type: ActionKeys.FILTER_REMOVE,
    payload: {
      filterValues,
      filterName,
      newFilterValue,
    },
  };
}

export function changeTabShown(tabName: string) {
  return <const>{
    type: ActionKeys.FILTER_CHANGE_TAB,
    payload: {
      tabName,
    },
  };
}

export function changeTabShownSuccess(tabName: string) {
  return <const>{
    type: ActionKeys.FILTER_CHANGE_TAB_SUCCESS,
    payload: {
      tabName,
    },
  };
}

export function tabClicked(tabName: string) {
  return <const>{
    type: ActionKeys.FILTER_TAB_CLICK,
    payload: {
      tabName,
    },
  };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function saveTempFilterGroup(filters: any) {
  return <const>{
    type: ActionKeys.FILTER_SAVE_TEMP_GROUP,
    payload: {
      filters,
    },
  };
}

export type FiltersActions =
  | ReturnType<typeof initFilters>
  | ReturnType<typeof changeFilter>
  | ReturnType<typeof resetFilters>
  | ReturnType<typeof openSaveFilterModal>
  | ReturnType<typeof closeSaveFilterGroupModal>
  | ReturnType<typeof openDeleteModal>
  | ReturnType<typeof closeDeleteModal>
  | ReturnType<typeof setSearchQueryValue>
  | ReturnType<typeof saveFilterGroup>
  | ReturnType<typeof saveFilterGroupSuccess>
  | ReturnType<typeof saveFilterGroupError>
  | ReturnType<typeof getFilterGroups>
  | ReturnType<typeof getFilterGroupsSuccess>
  | ReturnType<typeof getFilterGroupsError>
  | ReturnType<typeof deleteFilterGroup>
  | ReturnType<typeof deleteFilterGroupSuccess>
  | ReturnType<typeof deleteFilterGroupError>
  | ReturnType<typeof showNewTab>
  | ReturnType<typeof hideNewTab>
  | ReturnType<typeof determineTabName>
  | ReturnType<typeof removeFilter>
  | ReturnType<typeof changeTabShown>
  | ReturnType<typeof changeTabShownSuccess>
  | ReturnType<typeof tabClicked>
  | ReturnType<typeof saveTempFilterGroup>;
